/*************************
 * FAQ Accordion *
**************************/
function fnAccordion() {

	$('.faq-list-content').css({'display':'none'});

	$('.question h3').click(function(e){
		var item = $(this);
		//$('.accordion-step h3').removeClass('open');
		$(this).parent().siblings('.question').children('.faq-list-content').slideUp(250);
		$(this).parent().siblings().find('h3').removeClass('open');

		$(this).toggleClass('open');
		$(this).next().slideToggle(300);
	});
}
